import { countNeighbors, randBit, randColorString, repeat } from '../utils';

const step = (arr: number[][]): number[][] => {
  let next: number[][] = [];
  let size = arr.length;

  for (let y = 0; y < size; y++) {
    let row: number[] = new Array(5).fill(0);
    next[y] = row;
    if (y === 0 || y === size - 1) continue;
    row[0] = 0;

    for (let x = 1; x < row.length; x++) {
      let n = countNeighbors(arr, x, y);
      row[x] = arr[y][x] === 0 ? (n <= 1 ? 1 : 0) : n === 2 || n === 3 ? 1 : 0;
    }
  }
  return next;
};

const genMatrix = () => repeat(10, () => repeat(5, randBit));

export const randGlyph = (): { glyph: number[][]; colors: string[] } => ({
  glyph: step(step(step(genMatrix()))),
  colors: [randColorString(), randColorString(), randColorString()],
});
